import { Stack as H7 } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button, { ButtonType } from '~/components/shared/Button/button';
import Icon, { SvgSrc } from '~/components/shared/Icon/Icon';
import Stack from '~/components/shared/Layout/Stack';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useModals from '~/hooks/useModals';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import {
  StandardStepContent,
  StandardStepContentBody,
  StandardStepContentFooter,
} from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import { UploadDocumentsFooter } from './components/UploadDocumentsFooter';
import { UploadDocumentsModalBody } from './components/UploadDocumentsModalBody';
import StepHeader from '~/components/shared/Stepper/components/StepHeader';

export const UploadDocuments = () => {
  const dispatch = useAppDispatch();
  const {
    loanApplication: {
      form: { bankFilesUploaded },
    },
    matchedMedia,
  } = useSelector((state: RootState) => state);

  const t = useTranslate();
  const modals = useModals();

  const handleOpenUploadDocumentsModal = () => {
    modals.openModal({
      id: 'uploadDocuments-modal',
      header: <H7>{t('Onboarding.UploadFilesModalTitle')}</H7>,
      children: <UploadDocumentsModalBody />,
      size: 'md',
      fullScreen: matchedMedia.smallScreenPortrait,
      fixedHeaderAndFooter: true,
      hasOwnFooter: true,
      filledBackground: true,
      showBackButton: true,
    });

    dispatch(
      pushToGtmLoanAction({
        actionName: 'open_upload_documents_modal',
      })
    );
  };

  useEffect(() => {
    if (bankFilesUploaded) {
      handleOpenUploadDocumentsModal();
    }

    return () => {
      modals.closeModal('uploadDocuments-modal');
    };
  }, []);

  return (
    <StandardStepContent>
      <StandardStepContentBody>
        <StepHeader
          title={'Onboarding.ConnectToBankOrUploadDocumentsTitle'}
          description={'Onboarding.ConnectToBankOrUploadDocumentsDescription'}
        />
        <Stack
          alignContent="center"
          wrap={matchedMedia.mobile ? undefined : 'wrap'}
        >
          <Button
            type={ButtonType.SecondaryInverted}
            fullWidth
            onClick={handleOpenUploadDocumentsModal}
            textColor={theme.colors.dark}
            dataCy="upload_documents_button"
          >
            <Icon src={SvgSrc.FileUpload} mr={0.5} />
            {t('Onboarding.UploadBankTransactions')}
          </Button>
        </Stack>
      </StandardStepContentBody>
      <StandardStepContentFooter>
        <UploadDocumentsFooter />
      </StandardStepContentFooter>
    </StandardStepContent>
  );
};
